import React, { useEffect, useState } from "react";
import { Box, Grid, Card } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Helmet } from "react-helmet";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import OEE from "../../components/chart/nongjok/OEE";
import APQ from "../../components/chart/nongjok/OEE";
import BarChartAccumulativeProduction from "../../components/chart/BarChartAccumulativeProduction";
import BarChartAccumulativeTable from "../../components/chart/nongjok/BarChartAccumulativeTable";
import LensIcon from '@mui/icons-material/Lens';
import Fighting from '../../assets/img/renewal.png';
import axios from 'axios';
import { apiUrl } from '../../constants';
import moment from 'moment-timezone';
import CardContent from '@mui/material/CardContent';
import db from "../../firebase-config"



const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#f2f2f2',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    height: '90%',
    color: theme.palette.text.secondary,
}));




export default function Report() {
    const today = new Date();
    const hourago = new Date(today.getTime() - (24 * 60 * 60 * 1000));
    const timestr = moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD');
    const timestr_report = moment(hourago).tz('Asia/Bangkok').format('DD MMM YY');

    const [productionDetail, setProductionDetail] = useState([]);
    const [oeeDashboard, setOeeDashboard] = useState([]);
    const [getYield, setGetYield] = useState([])

    useEffect(() => {
        const today = moment().subtract(1, 'day').format("YYYY-MM-DD");
        const oeeSubscribe = db
            .collection("prod_mes_ignition_nongjok_oee")
            .onSnapshot((querySnapshot) => {
                const oeeDocs = [];

                querySnapshot.forEach((doc) => {
                    const data = { ...doc.data(), id: doc.id };
                    if (doc.id.includes(`4046_DAILY_OEE_${today}`)) {
                        oeeDocs.push(data);
                    }
                });
                const lastOee = oeeDocs[oeeDocs.length - 1];

                if (lastOee) {
                    setOeeDashboard(lastOee);
                } else {
                    setOeeDashboard([]);
                }

            });

        const subscriberProductionDetail = db
            .collection("prod_mes_ignition_nongjok_production_detail")
            .onSnapshot((querySnapshot) => {
                const productionDocs = [];

                querySnapshot.forEach((doc) => {
                    const data = { ...doc.data(), id: doc.id };
                    if (data.DATE === today) {
                        productionDocs.push(data);
                    }
                });
                const production = productionDocs;

                if (production) {
                    setProductionDetail(production);
                } else {
                    setProductionDetail([]);
                }

            });
        return () => {
            oeeSubscribe();
            subscriberProductionDetail();
        };
    }, []);


    useEffect(() => {
        async function fetchMyAPI() {
            //console.log("api_product: " + `${API.GET_PRODUCTION_DETAIL}${get_time_oee()}/`)
            await axios.get(`${apiUrl.GET_PRODUCTION_DETAIL}${timestr}/`, {
                headers: {
                    "X-xss-protection": "1; mode=block;",
                    "X-frame-options": "SAMEORIGIN",
                    "X-content-type-options": "nosniff",
                    "Cache-Control": "no-cache, private",
                    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
                    "Content-Security-Policy": "upgrade-insecure-requests; frame-ancestors 'self'"
                }
            }
            )
                .then(response => {
                    //console.log(response.data.PRODUCTION_DETAIL)
                    if (response.status == 200) {
                        setProductionDetail(response.data.PRODUCTION_DETAIL)

                    }
                })
                .catch(error => {
                    console.log('error: ', error)

                })
        }
        fetchMyAPI()

    }, []);


    useEffect(() => {
        async function fetchMyAPI() {
            //console.log("api_product: " + `${API.GET_PRODUCTION_DETAIL}${get_time_oee()}/`)
            await axios.get(`${apiUrl.GET_PRODUCTION_DETAIL}${timestr}/`, {
                headers: {
                    "X-xss-protection": "1; mode=block;",
                    "X-frame-options": "SAMEORIGIN",
                    "X-content-type-options": "nosniff",
                    "Cache-Control": "no-cache, private",
                    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
                    "Content-Security-Policy": "upgrade-insecure-requests; frame-ancestors 'self'"
                }
            }
            )
                .then(response => {
                    //console.log(response.data.PRODUCTION_DETAIL)
                    if (response.status == 200) {
                        setProductionDetail(response.data.PRODUCTION_DETAIL)

                    }
                })
                .catch(error => {
                    console.log('error: ', error)

                })
        }
        fetchMyAPI()
        const interval = setInterval(() => fetchMyAPI(), 1 * 60 * 1000)
        return () => {
            clearInterval(interval);
        }

    }, []);


    const accumulate_target = productionDetail.reduce((a, v) => a = a + v.TARGET, 0)

    const accumulate_actual = productionDetail.reduce((a, v) => a = a + v.ACTUAL_OUTPUT, 0)

    return (
        <>
            <Helmet>
                <title>Report | Dashboard Nongjok</title>
            </Helmet>
            <Grid
                container spacing={1}
                direction="row"
                alignItems="top"
                justifyContent="center"
                style={{ minHeight: '78vh', maxHeight: '200vh', flexGrow: 1, paddingLeft: 10, paddingTop: 0, paddingRight: 15 }}
            >
                {/* Top row */}
                <Grid id="top-row" container sx={{ pt: 1.0 }} spacing={1}>
                    <Box sx={{ width: '100%', bgcolor: "#a3b5af", display: 'flex', alignItems: 'center', justifyContent: 'center' }} height="50px" textAlign="center" >
                        <Typography style={{ color: "white", fontWeight: "bold", fontSize: "22px" }} textAlign="center" >
                            REPORT: {timestr_report}
                        </Typography>
                    </Box>
                </Grid>

                {/* left column */}
                <Grid container spacing={2} style={{ position: "relative", top: "10px", left: "-12px" }}>
                    <Grid item xs={12} md={7} lg={7} xl={7}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12} lg={12} xl={12}>
                                <Item>
                                    <Box width="100%" sx={{ background: "#a3b5af" }}>
                                        <Typography fontSize={'22px'} fontWeight="medium" style={{ color: "white" }}>
                                            ข้อมูลการผลิต
                                        </Typography>
                                    </Box>
                                    <Box mb={2} pt={0} px={0.5} display="flex" justifyContent="space-between" alignItems="center" style={{ position: "relative", top: "-20px", left: "0px" }}>
                                        <Grid container spacing="15px" alignItems="left" justifyContent="center">
                                            {/* oee */}
                                            <Grid item xs={6} md={3} lg={3} xl={3}>
                                                {oeeDashboard?.OEE > 100 ?
                                                    <OEE
                                                        value={[100]}
                                                        title='OEE'
                                                    />
                                                    : <OEE
                                                        value={[oeeDashboard?.OEE === 'NA' || oeeDashboard?.OEE === undefined ? 0 : Math.round(oeeDashboard?.OEE)]}
                                                        title='OEE'
                                                    />
                                                }
                                            </Grid>
                                            {/* a */}
                                            <Grid item xs={6} md={3} lg={3} xl={3}>
                                                {oeeDashboard?.A > 100 ?
                                                    <APQ
                                                        value={[100]}
                                                        title='AVA'
                                                        target='92'
                                                    />
                                                    : <APQ
                                                        value={[oeeDashboard?.A === 'NA' || oeeDashboard?.A === undefined ? 0 : Math.round(oeeDashboard?.A)]}
                                                        title='AVA'
                                                        target='92'
                                                    />
                                                }
                                            </Grid>
                                            {/* p */}
                                            <Grid item xs={6} md={3} lg={3} xl={3}>
                                                {oeeDashboard?.P > 100 ?
                                                    <APQ
                                                        value={[100]}
                                                        title='PER'
                                                        target='95'
                                                    />
                                                    : <APQ
                                                        value={[oeeDashboard?.P === 'NA' || oeeDashboard?.P === undefined ? 0 : Math.round(oeeDashboard?.P)]}
                                                        title='PER'
                                                        target='95'
                                                    />
                                                }
                                            </Grid>
                                            {/* q */}
                                            <Grid item xs={6} md={3} lg={3} xl={3}>
                                                {oeeDashboard?.Q > 100 ?
                                                    <APQ
                                                        value={[100]}
                                                        title='QUA'
                                                        target='98'
                                                    />
                                                    : <APQ
                                                        value={[oeeDashboard?.Q === 'NA' || oeeDashboard?.Q === undefined ? 0 : Math.floor(oeeDashboard?.Q)]}
                                                        title='QUA'
                                                        target='98'
                                                    />
                                                }
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    {/* ผลผลิตสะสม */}
                                    <Box pt={0} px={1} display="flex" justifyContent="space-between" alignItems="center" style={{ position: "relative", top: "15px", left: "0px" }}>
                                        <Grid sx={12} container spacing="7px" alignItems="center" justifyContent="center" >
                                            <Grid sm={12} container spacing="5px" alignItems="center" justifyContent="center" >
                                                <Grid item xs={12} md={7} lg={7} xl={7}>
                                                    <Card sx={{ bgcolor: "#ECF8F8" }} style={{ position: "relative", margin: "auto" }}>
                                                        <table style={{ 'padding-top': '30px' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td align="right" style={{ width: '80px', fontSize: 18, fontWeight: 'bold', borderBottom: 'none', height: "1px", color: "black" }}>ผลผลิตสะสม</td>
                                                                    <td align="left" >
                                                                        {productionDetail.length != 0 ?
                                                                            <BarChartAccumulativeProduction
                                                                                target_quantity={accumulate_target}
                                                                                actual_weight={accumulate_actual}
                                                                                target_now={0}
                                                                                unit='PAK'
                                                                                height='60%'
                                                                            />
                                                                            : <BarChartAccumulativeProduction
                                                                                target_quantity={0}
                                                                                actual_weight={0}
                                                                                target_now={0}
                                                                                unit='PAK'
                                                                                height='60%'
                                                                            />
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </Card>
                                                </Grid>

                                                <Grid item xs={12} md={5} lg={5} textAlign="left">
                                                    <Card sx={{ height: '95px', bgcolor: "#ECF8F8", display: 'flex', alignItems: 'center', justifyContent: 'center' }} style={{ position: "relative", left: '0px', top: '0px', borderRadius: 5 }}>
                                                        <CardContent>
                                                            <Typography style={{ color: "#000000", fontSize: 22, fontWeight: 'bold', top: "0px" }} textAlign="center">
                                                                <img src={Fighting} height="30px" /> Performance
                                                            </Typography>
                                                            <Typography style={{ color: "#000000", fontSize: 24, fontWeight: 'bold', position: "relative", left: "0px", top: "5px" }} textAlign="center">
                                                                {oeeDashboard?.TON_PER_HOUR === undefined || oeeDashboard?.TON_PER_HOUR === 'NA' ? 'NA' : (oeeDashboard?.TON_PER_HOUR * 1000).toFixed(2).toLocaleString()}&nbsp;&nbsp;kg/hr&nbsp;&nbsp;(std. {oeeDashboard?.AVG_STD_TON_PER_HOUR === undefined || oeeDashboard?.AVG_STD_TON_PER_HOUR === 'NA' ? 'NA' : Math.round(oeeDashboard?.AVG_STD_TON_PER_HOUR * 1000).toLocaleString()})
                                                            </Typography>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    {/* Yield */}
                                    <Box pt={1.5} px={4} display="flex" justifyContent="space-between" alignItems="left">
                                        <Grid container spacing={{ xs: 3, md: 3 }} columns={{ xs: 6, sm: 8, md: 12 }}>
                                            <Card sx={{ height: '200px' }} style={{ position: "relative", top: "35px" }}>
                                            </Card>
                                            {/*arrToObjectYield != 0 ? arrToObjectYield.map((item) => {
                                                return (
                                                    <Grid item xs={3} style={{ position: "relative", padding: 10 }}>
                                                        <GaugeChartYield
                                                            title={'Yield: ' + item.name}
                                                            value={[Math.floor(item.value)]}
                                                            input={'NA'}
                                                            output={'NA'}
                                                        />

                                                    </Grid>
                                                )
                                            }) : <Grid item xs={3} style={{ position: "relative", padding: 2 }}>
                                                <GaugeChartYield
                                                    title='Yield'
                                                    value={[0]}
                                                    input={'NA'}
                                                    output={'NA'}
                                                />
                                            </Grid>
                                            */}
                                        </Grid>
                                    </Box>
                                </Item>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* right column */}
                    {productionDetail.length > 3
                        ? <Grid item xs={12} md={5} lg={5} xl={5} >
                            <Item >
                                <Box width="100%" sx={{ background: "#a3b5af" }}>
                                    <Typography fontSize={'22px'} fontWeight="medium" style={{ color: "white" }}>
                                        รายการสินค้า&nbsp;&nbsp;&nbsp;
                                    </Typography>
                                </Box>
                                <Box pt={3} px={0.5} pl={1.5} display="flex" justifyContent="space-between" alignItems="left" >
                                    <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 1, sm: 1, md: 12 }}>
                                        {productionDetail.map((item) => {
                                            let colorStroke = item.STATUS == 'Running' ? "#00d084" : item.STATUS == 'Completed' ? "#00d084" : "#FFFFFF"

                                            const getColor = () => {
                                                let color;
                                                try {
                                                    if (item.STATUS == 'Completed') {
                                                        color = "#00d084"
                                                    } else if (item.STATUS == 'Running') {
                                                        color = "#e0e0e0"
                                                    } else if (item.STATUS == 'Not Start') {
                                                        color = "#FFFFFF"
                                                    }
                                                    return color;
                                                }
                                                catch {
                                                    console.log()
                                                }
                                            }
                                            return (
                                                <Grid item xs={6} style={{ position: "relative", padding: 2 }}>
                                                    <Card sx={{ width: "100%", bgcolor: "#ECF8F8", display: 'flex', alignItems: 'left', justifyContent: 'left' }} textAlign="left" >
                                                        <CardContent>
                                                            <Typography style={{ color: "#000000", fontSize: "14px", position: "relative", left: '0vw', top: "-5px" }} textAlign="left">
                                                                <LensIcon fontSize="small" stroke={colorStroke} strokeWidth="2" sx={{ color: getColor() }} style={{ position: "relative", left: '0px', top: '5px' }}>{item.STATUS} </LensIcon> {item.MATERIAL_DESCRIPTION}
                                                            </Typography>
                                                            <Typography style={{ color: "#ffffff", fontSize: "16px", position: "relative", left: '-10px', top: "10px" }} textAlign="left">
                                                                <BarChartAccumulativeTable
                                                                    target={item.TARGET}
                                                                    actual_output={item.ACTUAL_OUTPUT}
                                                                    status={item.STATUS}
                                                                    target_now={0}
                                                                    unit='PAK'
                                                                    height='50%'
                                                                    width='55%'
                                                                />
                                                            </Typography>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            )
                                        })}
                                    </Grid>
                                </Box>
                            </Item>
                        </Grid>
                        : <Grid item xs={12} md={5} lg={5} xl={5} >
                            <Item >
                                <Box width="100%" height="6%" sx={{ background: "#a3b5af" }}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center">
                                            <Typography fontSize={'22px'} fontWeight="medium" style={{ color: "white" }}>
                                                รายการสินค้า
                                            </Typography>
                                        </Grid>

                                    </Grid>
                                </Box>
                                <Box pt={4.2} px={3.5} display="flex" justifyContent="space-between" alignItems="left">
                                    <Grid container spacing={{ xs: 3, md: 3 }} columns={{ xs: 6, sm: 8, md: 12 }}>
                                        {productionDetail.map((item) => {
                                            let colorStroke = item.STATUS == 'Running' ? "#00d084" : item.STATUS == 'Completed' ? "#00d084" : "#FFFFFF"

                                            const getColor = () => {
                                                let color;
                                                try {
                                                    if (item.STATUS == 'Completed') {
                                                        color = "#00d084"
                                                    } else if (item.STATUS == 'Running') {
                                                        color = "#e0e0e0"
                                                    } else if (item.STATUS == 'Not Start') {
                                                        color = "#FFFFFF"
                                                    }
                                                    return color;
                                                }
                                                catch {
                                                    console.log()
                                                }
                                            }
                                            return (
                                                <Grid item xs={6} md={12} lg={12} xl={12} style={{ position: "relative", padding: 6 }}>
                                                    <Card sx={{ bgcolor: "#ECF8F8", display: 'flex', alignItems: 'left', justifyContent: 'left' }} textAlign="left" >
                                                        <CardContent>
                                                            <Typography style={{ color: "#000000", fontSize: 18, position: "relative", left: '0vw', top: "-5px" }} textAlign="left">
                                                                <LensIcon fontSize="small" stroke={colorStroke} strokeWidth="2" sx={{ color: getColor() }} style={{ position: "relative", left: '0px', top: '5px' }}>{item.STATUS} </LensIcon> {item.MATERIAL_DESCRIPTION}
                                                            </Typography>
                                                            <Typography style={{ color: "#ffffff", fontSize: "16px", position: "relative", left: '-10px', top: "10px" }} textAlign="left">
                                                                <BarChartAccumulativeTable
                                                                    target={item.TARGET}
                                                                    actual_output={item.ACTUAL_OUTPUT}
                                                                    status={item.STATUS}
                                                                    target_now={0}
                                                                    unit={item.PRODUCTION_UNIT}
                                                                    height='50%'
                                                                    width='100%'
                                                                />
                                                            </Typography>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            )
                                        })}
                                    </Grid>
                                </Box>
                            </Item>
                        </Grid>
                    }
                </Grid>
            </Grid>
        </>
    );
}

